export const banFilters = [
    { key: "banned", label: "Global" },
    { key: "allow_china", label: "China" },
    { key: "allow_russia", label: "Russia" },
    { key: "allow_islamic", label: "Islamic" },
];